var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManWorking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    transform: "translate(0.069 0.033)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16",
    transform: "translate(-0.069 -0.033)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25783",
    "data-name": "Group 25783",
    transform: "translate(-7.241 16.824)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25217",
    "data-name": "Group 25217",
    transform: "translate(5.746 193.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25216",
    "data-name": "Group 25216",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34375",
    "data-name": "Path 34375",
    d: "M288.292,441.978c0,3.4-33.4,6.157-74.591,6.157s-74.591-2.756-74.591-6.157,33.4-6.157,74.591-6.157S288.292,438.577,288.292,441.978Z",
    transform: "translate(-139.11 -435.821)",
    fill: "#ddd8ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25236",
    "data-name": "Group 25236",
    transform: "translate(36.295 172.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25226",
    "data-name": "Group 25226",
    transform: "translate(70.185)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25221",
    "data-name": "Group 25221",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25220",
    "data-name": "Group 25220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25219",
    "data-name": "Group 25219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25218",
    "data-name": "Group 25218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34376",
    "data-name": "Path 34376",
    d: "M316.621,403.611v22.808h9.464l5.409-19.388,2-7.182Z",
    transform: "translate(-316.621 -399.848)",
    fill: "#bf632d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25225",
    "data-name": "Group 25225",
    transform: "translate(0 0)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25224",
    "data-name": "Group 25224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25223",
    "data-name": "Group 25223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25222",
    "data-name": "Group 25222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34377",
    "data-name": "Path 34377",
    d: "M316.621,403.611v5.821c4.292-.477,10.412-1.562,14.873-2.4l2-7.182Z",
    transform: "translate(-316.621 -399.848)",
    fill: "#bf632d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25235",
    "data-name": "Group 25235"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25230",
    "data-name": "Group 25230",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25229",
    "data-name": "Group 25229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25228",
    "data-name": "Group 25228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25227",
    "data-name": "Group 25227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34378",
    "data-name": "Path 34378",
    d: "M209.819,403.611v22.808h-9.464l-5.409-19.388-2-7.182Z",
    transform: "translate(-192.943 -399.848)",
    fill: "#bf632d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25234",
    "data-name": "Group 25234",
    transform: "translate(0 0)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25233",
    "data-name": "Group 25233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25232",
    "data-name": "Group 25232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25231",
    "data-name": "Group 25231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34379",
    "data-name": "Path 34379",
    d: "M209.819,403.611v5.821c-4.292-.477-10.412-1.562-14.873-2.4l-2-7.182Z",
    transform: "translate(-192.943 -399.848)",
    fill: "#bf632d"
  })))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25248",
    "data-name": "Group 25248",
    transform: "translate(16.809 22.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25240",
    "data-name": "Group 25240",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25239",
    "data-name": "Group 25239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25238",
    "data-name": "Group 25238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25237",
    "data-name": "Group 25237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34380",
    "data-name": "Path 34380",
    d: "M159.323,161.1c.838,8.8,8.224,40.828,11.943,56.615.371,1.575.7,2.987.993,4.2.7,2.958,1.126,4.72,1.126,4.72l79.6-1.67s.222-1.019.607-2.823c2.846-13.325,14.59-69.514,11.488-74.989a4.636,4.636,0,0,0-.958-1.138,9.034,9.034,0,0,0-1.027-.784,14.833,14.833,0,0,0-1.3-.762c-5.76-3.043-17.772-5.575-31.413-7.07-16.086-1.767-34.436-2.088-47.459-.1-.372.057-.74.116-1.1.177q-1.423.234-2.733.484c-17.072,3.234-20.377,7.88-20.483,14.461v.006A85.929,85.929,0,0,0,159.323,161.1Z",
    transform: "translate(-158.605 -135.936)",
    fill: "#fe812d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25243",
    "data-name": "Group 25243",
    transform: "translate(15.89 5.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25242",
    "data-name": "Group 25242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25241",
    "data-name": "Group 25241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34381",
    "data-name": "Path 34381",
    d: "M264.591,212.035a.346.346,0,0,0,.34-.284c.025-.138,2.549-14,4.585-28.1,1.2-8.284,1.992-15.026,2.366-20.041.642-8.605-.087-10.321-.691-10.864-3.5-3.137-21.584-5.541-32.056-6.7a101.05,101.05,0,0,0-15.186-.519c-12.107.5-32.944,1.824-36.473,5.081-.6.551-1.3,2.277-.54,10.873.444,5.009,1.335,11.739,2.647,20,2.232,14.067,4.949,27.9,4.976,28.035a.346.346,0,0,0,.678-.133c-.027-.138-2.742-13.957-4.972-28.011-3.9-24.591-3.129-29.514-2.321-30.26,2.459-2.269,15.593-4.055,36.032-4.9a100.352,100.352,0,0,1,15.082.515c10.388,1.145,28.318,3.515,31.669,6.523.819.735,1.661,5.646-1.9,30.29-2.034,14.084-4.555,27.94-4.581,28.077a.346.346,0,0,0,.278.4A.339.339,0,0,0,264.591,212.035Z",
    transform: "translate(-186.605 -145.446)",
    fill: "#bf632d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25247",
    "data-name": "Group 25247",
    transform: "translate(0.003 2.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25246",
    "data-name": "Group 25246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25245",
    "data-name": "Group 25245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25244",
    "data-name": "Group 25244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34382",
    "data-name": "Path 34382",
    d: "M158.609,153.964v.006c.034,2.409.436,5.07.716,8.008.838,8.8,8.224,40.828,11.942,56.616h13.007s-14.343-52.312-15.187-65.179c-.551-8.4,5.638-12.25,10-13.911C162.021,142.736,158.715,147.383,158.609,153.964Z",
    transform: "translate(-158.609 -139.503)",
    fill: "#bf632d"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25271",
    "data-name": "Group 25271",
    transform: "translate(111.48 85.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25252",
    "data-name": "Group 25252",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25251",
    "data-name": "Group 25251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25250",
    "data-name": "Group 25250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25249",
    "data-name": "Group 25249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34383",
    "data-name": "Path 34383",
    d: "M325.7,270.923s13.389-1.3,14.486,3.547c.855,3.78-.291,37.63-.836,52.34a7.082,7.082,0,0,0,6.682,7.333c.852.048,1.75.091,2.673.124,4.435.158,9.467.1,12.915-.683,7.511-1.7,7.753-12.355,10.418-30.042s5.088-49.181-11.386-55.237c-.567-.208-1.136-.4-1.7-.569-15.874-4.8-31.006,4.687-31.006,4.687A40.082,40.082,0,0,0,325.7,270.923Z",
    transform: "translate(-325.43 -246.381)",
    fill: "#bf632d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25257",
    "data-name": "Group 25257",
    transform: "translate(23.273 1.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25256",
    "data-name": "Group 25256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25255",
    "data-name": "Group 25255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25254",
    "data-name": "Group 25254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25253",
    "data-name": "Group 25253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34384",
    "data-name": "Path 34384",
    d: "M366.44,335.3c4.435.158,9.467.1,12.915-.683,7.511-1.7,7.753-12.355,10.418-30.042s5.088-49.181-11.386-55.237c-.567-.208-1.135-.4-1.7-.569-2.807.67-5.387,2.533-6.779,6.625C366.134,266.494,372.126,305.065,366.44,335.3Z",
    transform: "translate(-366.44 -248.769)",
    fill: "#fe812d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25261",
    "data-name": "Group 25261",
    transform: "translate(26.626 38.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25260",
    "data-name": "Group 25260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25259",
    "data-name": "Group 25259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25258",
    "data-name": "Group 25258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34385",
    "data-name": "Path 34385",
    d: "M377.769,361.307a8.5,8.5,0,0,0,7.709-4.1c2.545-4.2,6.215-40.265,6.37-41.8a.342.342,0,1,0-.68-.069c-.038.374-3.81,37.441-6.275,41.513-3.738,6.177-11.988,2.883-12.071,2.849a.342.342,0,0,0-.259.633,15.2,15.2,0,0,0,4.893.968C377.56,361.306,377.665,361.307,377.769,361.307Z",
    transform: "translate(-372.349 -315.033)",
    fill: "#bf632d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25266",
    "data-name": "Group 25266",
    transform: "translate(30.811 8.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25265",
    "data-name": "Group 25265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25264",
    "data-name": "Group 25264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25263",
    "data-name": "Group 25263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25262",
    "data-name": "Group 25262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34386",
    "data-name": "Path 34386",
    d: "M379.732,267.179s.269-6.052,4.837-5.573,4.787,10.465.7,11.756C379.3,275.251,379.732,267.179,379.732,267.179Z",
    transform: "translate(-379.725 -261.579)",
    fill: "#bf632d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25270",
    "data-name": "Group 25270",
    transform: "translate(28.394 5.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25269",
    "data-name": "Group 25269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25268",
    "data-name": "Group 25268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25267",
    "data-name": "Group 25267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34387",
    "data-name": "Path 34387",
    d: "M388.407,262.784a.335.335,0,0,0,.074-.008.342.342,0,0,0,.26-.408c-.05-.225-1.273-5.531-5.694-6.587a5.3,5.3,0,0,0-4.729.956,8.3,8.3,0,0,0-2.854,5.706.342.342,0,0,0,.684,0,7.67,7.67,0,0,1,2.593-5.169,4.643,4.643,0,0,1,4.146-.827c4.009.958,5.174,6.019,5.185,6.07A.342.342,0,0,0,388.407,262.784Z",
    transform: "translate(-375.464 -255.597)",
    fill: "#bf632d"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25275",
    "data-name": "Group 25275",
    transform: "translate(18.616 106.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25274",
    "data-name": "Group 25274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25273",
    "data-name": "Group 25273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25272",
    "data-name": "Group 25272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34388",
    "data-name": "Path 34388",
    d: "M161.789,284.434c.853,3.6,1.37,5.74,1.37,5.74l96.815-2.032s.27-1.238.737-3.433C243.553,281.793,184.676,282.778,161.789,284.434Z",
    transform: "translate(-161.789 -282.847)",
    fill: "#bf632d"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25288",
    "data-name": "Group 25288",
    transform: "translate(19.355 108.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25279",
    "data-name": "Group 25279",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25278",
    "data-name": "Group 25278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25277",
    "data-name": "Group 25277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25276",
    "data-name": "Group 25276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34389",
    "data-name": "Path 34389",
    d: "M163.124,304.437c.024,1.825.064,3.758.124,5.763.539,18.044,2.747,41.832,10.573,43.917,12.741,3.4,91.8,5.125,95.931-2.429,1.233-2.255,2-6.05,2.5-10.694.1-.91.184-1.852.263-2.822.679-8.406.686-18.863.967-27.972.077-2.448.171-4.8.305-6.986.98-16.056-12.087-16.284-12.087-16.284-18.476-.432-45.618.433-66.729,1.324-11.008.465-20.376.936-26.021,1.233-3.631.192-5.722.312-5.722.312S163.011,295.943,163.124,304.437Z",
    transform: "translate(-163.092 -286.816)",
    fill: "#fe812d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25283",
    "data-name": "Group 25283",
    transform: "translate(26.877 47.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25282",
    "data-name": "Group 25282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25281",
    "data-name": "Group 25281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25280",
    "data-name": "Group 25280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34390",
    "data-name": "Path 34390",
    d: "M245.524,377.228q2.391,0,4.933-.051c25.516-.519,40.2-6.263,40.348-6.321a.421.421,0,0,0-.312-.781c-.144.057-14.7,5.745-40.054,6.262-25.381.515-39.32-3.1-39.458-3.132a.421.421,0,0,0-.216.813C210.9,374.052,223.153,377.228,245.524,377.228Z",
    transform: "translate(-210.453 -370.045)",
    fill: "#bf632d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25287",
    "data-name": "Group 25287",
    transform: "translate(0.033 1.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25286",
    "data-name": "Group 25286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25285",
    "data-name": "Group 25285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25284",
    "data-name": "Group 25284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34391",
    "data-name": "Path 34391",
    d: "M163.149,305.534c.024,1.825.064,3.758.124,5.763.539,18.044,2.747,41.832,10.573,43.917,12.741,3.4,91.8,5.125,95.931-2.429,1.233-2.255,2-6.05,2.5-10.694.1-.91.184-1.852.263-2.822-3.749,2.5-15,5.78-22.739,6.573a227.782,227.782,0,0,1-57.334-1.2c4.233-17.455,3.11-45.328,2.529-55.293-11.008.465-20.376.936-26.021,1.233Z",
    transform: "translate(-163.149 -289.351)",
    fill: "#bf632d"
  }))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25719",
    "data-name": "Group 25719",
    transform: "translate(34.831 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25537",
    "data-name": "Group 25537",
    transform: "translate(26.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25346",
    "data-name": "Group 25346",
    transform: "translate(0 33.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25298",
    "data-name": "Group 25298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25297",
    "data-name": "Group 25297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25296",
    "data-name": "Group 25296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25295",
    "data-name": "Group 25295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25294",
    "data-name": "Group 25294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25293",
    "data-name": "Group 25293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25292",
    "data-name": "Group 25292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25291",
    "data-name": "Group 25291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25290",
    "data-name": "Group 25290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25289",
    "data-name": "Group 25289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34392",
    "data-name": "Path 34392",
    d: "M290.255,233.778a24.678,24.678,0,0,1-3.174,2.4c-.036.025-.075.047-.111.069-.819.524-1.692,1.021-2.607,1.49-.328.167-.661.331-1,.49a44.259,44.259,0,0,1-8.911,3.058c-.293.072-.589.137-.887.2-.859.185-1.731.35-2.615.489-.3.051-.593.094-.891.137a52.575,52.575,0,0,1-10.589.437q-.636-.037-1.271-.094-1.692-.14-3.383-.407c-.028,0-.053-.009-.081-.012q-.509-.081-1.018-.173a45.178,45.178,0,0,1-5.414-1.323,40.134,40.134,0,0,1-4.577-1.727c-.255-.111-.507-.23-.759-.346-.314-.151-.627-.3-.936-.461l-.088-.042c-1.769-5.111-3.492-23.274-3.941-28.7-.093-1.081-.16-2.162-.214-3.242-.117-2.445-.142-4.894-.1-7.374.006-.325.011-.647.022-.975,0-.18.007-.363.012-.545.064-2.305.181-4.637.333-7.017.018-.3.039-.594.056-.893q.149-2.166.322-4.383c.246-3.14.524-6.373.8-9.741.439-5.42,1.667-9.673,3.643-12.531a11.1,11.1,0,0,1,1.634-1.891,8.471,8.471,0,0,1,4.613-2.187,24.6,24.6,0,0,0,2.97-.6c.168-.043.329-.088.49-.136.508-.146.986-.3,1.433-.467.516-.189.992-.386,1.425-.582l.2-.09c.116-.057.231-.108.341-.164a17.813,17.813,0,0,0,2.908-1.729l12.7.225c.1.146.2.288.295.424.01.01.015.02.023.028a9.5,9.5,0,0,0,2.951,2.584c.206.121.418.231.626.337.161.084.327.161.494.237s.345.151.519.222c.414.17.83.322,1.249.466l.015,0c3.06,1.037,6.18,1.514,7.856,3.817a5.767,5.767,0,0,1,.66,1.188,7.352,7.352,0,0,1,.426,1.491,6.1,6.1,0,0,1,.091,1.015c.061,3.727-2.206,10.671-2.187,23.63q0,1.212.032,2.487c.006.254.011.511.02.767.013.526.035,1.06.058,1.6v0c.026.544.052,1.1.085,1.66.058,1.048.132,2.131.225,3.24q.115,1.461.277,3,.163,1.573.367,3.23c.549,4.393,1.8,13.117,3.15,20.451.211,1.154.427,2.273.642,3.336.023.112.044.222.068.331C289.776,231.672,290.016,232.778,290.255,233.778Z",
    transform: "translate(-237.672 -154.714)",
    fill: "#7c7a48"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25303",
    "data-name": "Group 25303",
    transform: "translate(31.388 23.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25302",
    "data-name": "Group 25302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25301",
    "data-name": "Group 25301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25300",
    "data-name": "Group 25300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25299",
    "data-name": "Group 25299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34393",
    "data-name": "Path 34393",
    d: "M293.013,196.7l11.385-.675s3.042,14.948-4.065,15.561C292.095,212.292,293.013,196.7,293.013,196.7Z",
    transform: "translate(-292.982 -196.021)",
    fill: "#504f2c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25309",
    "data-name": "Group 25309",
    transform: "translate(19.106 0.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25308",
    "data-name": "Group 25308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25307",
    "data-name": "Group 25307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25306",
    "data-name": "Group 25306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25305",
    "data-name": "Group 25305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25304",
    "data-name": "Group 25304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34394",
    "data-name": "Path 34394",
    d: "M281.04,167.088c-2.69-.048-5.14-1.763-7.15-5.027a24.409,24.409,0,0,1-2.535-5.809.475.475,0,0,1,.918-.246c.03.113,3.1,11.256,9.918,10.039a5.619,5.619,0,0,0,3.942-2.432c1.826-2.834.781-7.049.77-7.091a.475.475,0,0,1,.921-.234c.048.188,1.155,4.662-.892,7.84a6.531,6.531,0,0,1-4.575,2.853A6.827,6.827,0,0,1,281.04,167.088Z",
    transform: "translate(-271.339 -155.653)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25318",
    "data-name": "Group 25318",
    transform: "translate(15.669 12.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25317",
    "data-name": "Group 25317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25316",
    "data-name": "Group 25316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25315",
    "data-name": "Group 25315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25314",
    "data-name": "Group 25314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25313",
    "data-name": "Group 25313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25312",
    "data-name": "Group 25312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25311",
    "data-name": "Group 25311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25310",
    "data-name": "Group 25310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34395",
    "data-name": "Path 34395",
    d: "M279.286,184.15a15.946,15.946,0,0,1-6.825-1.856,29.179,29.179,0,0,1-7.094-5.165.318.318,0,0,1-.007-.423.26.26,0,0,1,.389-.008,28.617,28.617,0,0,0,6.956,5.06c5.33,2.671,9.962,2.387,13.768-.843a.261.261,0,0,1,.387.051.318.318,0,0,1-.048.42,11.063,11.063,0,0,1-7.431,2.766Z",
    transform: "translate(-265.284 -176.614)",
    fill: "#504f2c"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25327",
    "data-name": "Group 25327",
    transform: "translate(22.879 11.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25326",
    "data-name": "Group 25326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25325",
    "data-name": "Group 25325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25324",
    "data-name": "Group 25324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25323",
    "data-name": "Group 25323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25322",
    "data-name": "Group 25322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25321",
    "data-name": "Group 25321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25320",
    "data-name": "Group 25320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25319",
    "data-name": "Group 25319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34396",
    "data-name": "Path 34396",
    d: "M284.722,178.009c-2.992-.053-6.428-2.689-6.617-2.836a.316.316,0,0,1-.063-.418.262.262,0,0,1,.384-.07c.057.045,5.8,4.449,8.552,1.962a.26.26,0,0,1,.388.039.317.317,0,0,1-.036.421A3.657,3.657,0,0,1,284.722,178.009Z",
    transform: "translate(-277.989 -174.63)",
    fill: "#504f2c"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25336",
    "data-name": "Group 25336",
    transform: "translate(8.626 47.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25335",
    "data-name": "Group 25335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25334",
    "data-name": "Group 25334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25333",
    "data-name": "Group 25333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25332",
    "data-name": "Group 25332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25331",
    "data-name": "Group 25331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25330",
    "data-name": "Group 25330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25329",
    "data-name": "Group 25329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25328",
    "data-name": "Group 25328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34397",
    "data-name": "Path 34397",
    d: "M273.94,248.8a20.043,20.043,0,0,1-3.43-.365,28.612,28.612,0,0,1-8.873-3.47,42.87,42.87,0,0,1-8.682-6.707.317.317,0,0,1,0-.423.26.26,0,0,1,.389-.006,42.315,42.315,0,0,0,8.57,6.615c4.655,2.7,11.654,5.335,18.571,2.587a.27.27,0,0,1,.353.178.308.308,0,0,1-.165.384A17.255,17.255,0,0,1,273.94,248.8Z",
    transform: "translate(-252.872 -237.749)",
    fill: "#504f2c"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25345",
    "data-name": "Group 25345",
    transform: "translate(11.287 39.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25344",
    "data-name": "Group 25344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25343",
    "data-name": "Group 25343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25342",
    "data-name": "Group 25342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25341",
    "data-name": "Group 25341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25340",
    "data-name": "Group 25340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25339",
    "data-name": "Group 25339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25338",
    "data-name": "Group 25338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25337",
    "data-name": "Group 25337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34398",
    "data-name": "Path 34398",
    d: "M280.527,230.7a20.07,20.07,0,0,1-3.424.422,28.619,28.619,0,0,1-9.429-1.368,42.884,42.884,0,0,1-9.976-4.565.317.317,0,0,1-.1-.411.26.26,0,0,1,.379-.094,42.3,42.3,0,0,0,9.846,4.5c5.144,1.572,12.56,2.555,18.674-1.688a.269.269,0,0,1,.384.093.308.308,0,0,1-.074.411A17.25,17.25,0,0,1,280.527,230.7Z",
    transform: "translate(-257.561 -224.64)",
    fill: "#504f2c"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25536",
    "data-name": "Group 25536",
    transform: "translate(19.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25535",
    "data-name": "Group 25535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25363",
    "data-name": "Group 25363",
    transform: "translate(1.669 23.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25362",
    "data-name": "Group 25362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25361",
    "data-name": "Group 25361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25352",
    "data-name": "Group 25352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25351",
    "data-name": "Group 25351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25350",
    "data-name": "Group 25350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25349",
    "data-name": "Group 25349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25348",
    "data-name": "Group 25348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25347",
    "data-name": "Group 25347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34399",
    "data-name": "Path 34399",
    d: "M288.222,147.161l-.541,3.277a10.37,10.37,0,0,1-1.3.622c-6.276,2.48-11.74-2.761-11.74-2.761l1.876-11.363,10.308,9.005Z",
    transform: "translate(-274.643 -136.937)",
    fill: "#ebb088"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25360",
    "data-name": "Group 25360",
    transform: "translate(4.492 5.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25359",
    "data-name": "Group 25359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25358",
    "data-name": "Group 25358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25357",
    "data-name": "Group 25357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25356",
    "data-name": "Group 25356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25355",
    "data-name": "Group 25355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25354",
    "data-name": "Group 25354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25353",
    "data-name": "Group 25353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34400",
    "data-name": "Path 34400",
    d: "M291.646,151.538l-.541,3.277a10.363,10.363,0,0,1-1.3.622c-4.547-2.716-7.247-8.381-7.247-8.381l7.691,3.262Z",
    transform: "translate(-282.559 -147.057)",
    fill: "#341a1b"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25534",
    "data-name": "Group 25534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25371",
    "data-name": "Group 25371",
    transform: "translate(21.335 6.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25370",
    "data-name": "Group 25370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25369",
    "data-name": "Group 25369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25368",
    "data-name": "Group 25368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25367",
    "data-name": "Group 25367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25366",
    "data-name": "Group 25366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25365",
    "data-name": "Group 25365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25364",
    "data-name": "Group 25364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34401",
    "data-name": "Path 34401",
    d: "M309.354,107.545s6.11,2.648,2.9,7.449C312.259,114.994,308.813,109.68,309.354,107.545Z",
    transform: "translate(-309.297 -107.545)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25379",
    "data-name": "Group 25379",
    transform: "translate(21.104 19.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25378",
    "data-name": "Group 25378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25377",
    "data-name": "Group 25377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25376",
    "data-name": "Group 25376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25375",
    "data-name": "Group 25375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25374",
    "data-name": "Group 25374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25373",
    "data-name": "Group 25373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25372",
    "data-name": "Group 25372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34402",
    "data-name": "Path 34402",
    d: "M309.543,130s2.231-1.893,2.924.48-.854,6.69-3.577,5.495Z",
    transform: "translate(-308.89 -129.289)",
    fill: "#ff7d5b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25387",
    "data-name": "Group 25387",
    transform: "translate(3.172 5.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25386",
    "data-name": "Group 25386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25385",
    "data-name": "Group 25385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25384",
    "data-name": "Group 25384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25383",
    "data-name": "Group 25383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25382",
    "data-name": "Group 25382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25381",
    "data-name": "Group 25381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25380",
    "data-name": "Group 25380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34403",
    "data-name": "Path 34403",
    d: "M296.6,127.576s-1.109,6.777-8.18,5.6c-7.028-1.166-10.911-7.453-11.118-7.748l-.007-.008.158-1.436.821-7.457.438-3.986s.276-7.26,7.276-7.445c5.114-.135,9.628,1.448,11.548,4.41a6.128,6.128,0,0,1,.964,3.823l-.952,7.133-.233,1.747Z",
    transform: "translate(-277.29 -105.089)",
    fill: "#ebb088"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25395",
    "data-name": "Group 25395",
    transform: "translate(2.134 5.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25394",
    "data-name": "Group 25394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25393",
    "data-name": "Group 25393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25392",
    "data-name": "Group 25392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25391",
    "data-name": "Group 25391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25390",
    "data-name": "Group 25390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25389",
    "data-name": "Group 25389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25388",
    "data-name": "Group 25388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34404",
    "data-name": "Path 34404",
    d: "M275.476,112.785c0,.058-.006.115-.008.171a6.265,6.265,0,0,0,.034.987,6,6,0,0,0,.53,1.827,4.2,4.2,0,0,1,2.879,3.088l1.728.521a17.552,17.552,0,0,0,.462-5.109c-.144-1.343.8-1.81,1.52-2.59v0a2.886,2.886,0,0,0,.561-.831,1.884,1.884,0,0,0,.213-1.286,6.708,6.708,0,0,1,5.7-.1c2.859,1.423,5.56,2.194,7.238.6a1.557,1.557,0,0,0,.411-.556c-1.921-2.961-6.434-4.545-11.548-4.409-7,.184-9.081,3.21-9.081,3.21C275.312,109.891,275.57,111.325,275.476,112.785Z",
    transform: "translate(-275.462 -105.089)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25397",
    "data-name": "Group 25397",
    transform: "translate(2.174 11.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25396",
    "data-name": "Group 25396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34405",
    "data-name": "Path 34405",
    d: "M275.532,118.967a6.005,6.005,0,0,0,.53,1.827,4.2,4.2,0,0,1,2.879,3.088l1.728.521a17.554,17.554,0,0,0,.462-5.109c-.144-1.343.8-1.81,1.52-2.59C281.147,116.808,277.93,118.111,275.532,118.967Z",
    transform: "translate(-275.532 -116.704)",
    fill: "#341a1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25434",
    "data-name": "Group 25434",
    transform: "translate(1.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25399",
    "data-name": "Group 25399",
    transform: "translate(0.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25398",
    "data-name": "Group 25398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34406",
    "data-name": "Path 34406",
    d: "M274.785,103.876s11.734-2.534,19.611-1.513c.205.027.409.056.609.089a14.684,14.684,0,0,1,2.269.528s-.835-4.236-6-6.287a14.082,14.082,0,0,0-1.937-.608,18.1,18.1,0,0,0-3.119-.442l-.113-.007q-.453-.025-.882-.023a14.006,14.006,0,0,0-2.449.2q-.295.05-.575.113a10.348,10.348,0,0,0-3.516,1.474,9.565,9.565,0,0,0-.877.658A8.582,8.582,0,0,0,274.785,103.876Z",
    transform: "translate(-274.785 -95.613)",
    fill: "#fb532c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25406",
    "data-name": "Group 25406",
    transform: "translate(14.904 0.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25405",
    "data-name": "Group 25405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25404",
    "data-name": "Group 25404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25403",
    "data-name": "Group 25403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25402",
    "data-name": "Group 25402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25401",
    "data-name": "Group 25401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25400",
    "data-name": "Group 25400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34407",
    "data-name": "Path 34407",
    d: "M300.43,96.445a10.341,10.341,0,0,1,5.057,6.278q.08.286.145.587l.554-.119c-.028-.128-.058-.256-.09-.38a10.639,10.639,0,0,0-3.73-5.758A14.081,14.081,0,0,0,300.43,96.445Z",
    transform: "translate(-300.43 -96.445)",
    fill: "#a62413"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25413",
    "data-name": "Group 25413",
    transform: "translate(10.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25412",
    "data-name": "Group 25412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25411",
    "data-name": "Group 25411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25410",
    "data-name": "Group 25410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25409",
    "data-name": "Group 25409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25408",
    "data-name": "Group 25408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25407",
    "data-name": "Group 25407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34408",
    "data-name": "Path 34408",
    d: "M293.178,95.613a9.166,9.166,0,0,1,3.353,5.032l.552-.127a9.961,9.961,0,0,0-2.909-4.875l-.114-.007Q293.608,95.611,293.178,95.613Z",
    transform: "translate(-293.178 -95.613)",
    fill: "#a62413"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25420",
    "data-name": "Group 25420",
    transform: "translate(7.761 0.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25419",
    "data-name": "Group 25419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25418",
    "data-name": "Group 25418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25417",
    "data-name": "Group 25417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25416",
    "data-name": "Group 25416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25415",
    "data-name": "Group 25415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25414",
    "data-name": "Group 25414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34409",
    "data-name": "Path 34409",
    d: "M287.846,96.077c-.035,1.418.174,4.393,2.3,6.246l.373-.424c-1.995-1.739-2.137-4.67-2.1-5.935C288.225,96,288.034,96.035,287.846,96.077Z",
    transform: "translate(-287.843 -95.964)",
    fill: "#a62413"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25427",
    "data-name": "Group 25427",
    transform: "translate(2.775 1.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25426",
    "data-name": "Group 25426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25425",
    "data-name": "Group 25425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25424",
    "data-name": "Group 25424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25423",
    "data-name": "Group 25423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25422",
    "data-name": "Group 25422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25421",
    "data-name": "Group 25421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34410",
    "data-name": "Path 34410",
    d: "M279.425,104.676l.53-.2c-.737-1.912-.082-4.179.575-5.713a9.567,9.567,0,0,0-.877.658A7.759,7.759,0,0,0,279.425,104.676Z",
    transform: "translate(-279.057 -98.761)",
    fill: "#a62413"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25433",
    "data-name": "Group 25433",
    transform: "translate(0 4.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25432",
    "data-name": "Group 25432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25431",
    "data-name": "Group 25431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25430",
    "data-name": "Group 25430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25429",
    "data-name": "Group 25429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25428",
    "data-name": "Group 25428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34411",
    "data-name": "Path 34411",
    d: "M297.443,108.65a29.121,29.121,0,0,0-22.5,2.306,3.547,3.547,0,0,1-.4-3.786s11.194-7.13,22.573-1.408A2.737,2.737,0,0,1,297.443,108.65Z",
    transform: "translate(-274.166 -103.539)",
    fill: "#a62413"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25443",
    "data-name": "Group 25443",
    transform: "translate(9.494 18.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25442",
    "data-name": "Group 25442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25441",
    "data-name": "Group 25441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25440",
    "data-name": "Group 25440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25439",
    "data-name": "Group 25439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25438",
    "data-name": "Group 25438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25437",
    "data-name": "Group 25437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25436",
    "data-name": "Group 25436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25435",
    "data-name": "Group 25435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34412",
    "data-name": "Path 34412",
    d: "M292.992,130.026c-.081.493-1.167.726-2.425.519s-2.212-.773-2.131-1.267,1.167-.726,2.425-.52S293.074,129.532,292.992,130.026Z",
    transform: "translate(-288.431 -128.683)",
    fill: "#ff7d5b"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25452",
    "data-name": "Group 25452",
    transform: "translate(20.505 20.573)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25451",
    "data-name": "Group 25451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25450",
    "data-name": "Group 25450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25449",
    "data-name": "Group 25449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25448",
    "data-name": "Group 25448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25447",
    "data-name": "Group 25447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25446",
    "data-name": "Group 25446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25445",
    "data-name": "Group 25445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25444",
    "data-name": "Group 25444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34413",
    "data-name": "Path 34413",
    d: "M310.522,133.791a5.568,5.568,0,0,1-.553-.064c-1.257-.206-2.211-.774-2.129-1.267s1.167-.726,2.424-.52q.255.042.491.1Z",
    transform: "translate(-307.834 -131.865)",
    fill: "#ff7d5b"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25493",
    "data-name": "Group 25493",
    transform: "translate(11.494 12.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25460",
    "data-name": "Group 25460",
    transform: "translate(2.017 4.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25459",
    "data-name": "Group 25459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25458",
    "data-name": "Group 25458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25457",
    "data-name": "Group 25457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25456",
    "data-name": "Group 25456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25455",
    "data-name": "Group 25455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25454",
    "data-name": "Group 25454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25453",
    "data-name": "Group 25453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34414",
    "data-name": "Path 34414",
    d: "M296.917,125.359c-.112.678-.511,1.176-.892,1.113s-.6-.662-.486-1.34.511-1.176.892-1.113S297.028,124.681,296.917,125.359Z",
    transform: "translate(-295.509 -124.014)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25468",
    "data-name": "Group 25468",
    transform: "translate(8.746 5.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25467",
    "data-name": "Group 25467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25466",
    "data-name": "Group 25466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25465",
    "data-name": "Group 25465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25464",
    "data-name": "Group 25464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25463",
    "data-name": "Group 25463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25462",
    "data-name": "Group 25462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25461",
    "data-name": "Group 25461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34415",
    "data-name": "Path 34415",
    d: "M308.773,127.3c-.112.678-.511,1.176-.892,1.113s-.6-.662-.486-1.34.511-1.176.891-1.113S308.885,126.626,308.773,127.3Z",
    transform: "translate(-307.366 -125.959)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25476",
    "data-name": "Group 25476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25475",
    "data-name": "Group 25475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25474",
    "data-name": "Group 25474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25473",
    "data-name": "Group 25473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25472",
    "data-name": "Group 25472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25471",
    "data-name": "Group 25471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25470",
    "data-name": "Group 25470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25469",
    "data-name": "Group 25469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34416",
    "data-name": "Path 34416",
    d: "M292,118.484c.274-.69,1.094-1.935,3.406-1.66a.61.61,0,0,1,.534.541h0a.607.607,0,0,1-.592.672,2.732,2.732,0,0,0-2.234,1.1.609.609,0,0,1-.888.086l-.062-.054A.609.609,0,0,1,292,118.484Z",
    transform: "translate(-291.955 -116.784)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25484",
    "data-name": "Group 25484",
    transform: "translate(8.381 0.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25483",
    "data-name": "Group 25483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25482",
    "data-name": "Group 25482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25481",
    "data-name": "Group 25481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25480",
    "data-name": "Group 25480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25479",
    "data-name": "Group 25479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25478",
    "data-name": "Group 25478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25477",
    "data-name": "Group 25477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34417",
    "data-name": "Path 34417",
    d: "M310.152,121.142c-.038-.741-.414-2.183-2.693-2.661a.611.611,0,0,0-.679.342h0a.605.605,0,0,0,.345.826,2.724,2.724,0,0,1,1.762,1.757.608.608,0,0,0,.814.364l.076-.031A.611.611,0,0,0,310.152,121.142Z",
    transform: "translate(-306.723 -118.468)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25492",
    "data-name": "Group 25492",
    transform: "translate(1.949 9.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25491",
    "data-name": "Group 25491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25490",
    "data-name": "Group 25490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25489",
    "data-name": "Group 25489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25488",
    "data-name": "Group 25488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25487",
    "data-name": "Group 25487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25486",
    "data-name": "Group 25486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25485",
    "data-name": "Group 25485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34418",
    "data-name": "Path 34418",
    d: "M295.438,134.258a7.319,7.319,0,0,0,4.193,2.9,4.378,4.378,0,0,0,2.686-.424.283.283,0,1,0-.25-.507c-3.441,1.684-6.131-2.241-6.157-2.281a.284.284,0,0,0-.393-.078.282.282,0,0,0-.078.392",
    transform: "translate(-295.39 -133.819)",
    fill: "#341a1b"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25501",
    "data-name": "Group 25501",
    transform: "translate(3.172 23.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25500",
    "data-name": "Group 25500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25499",
    "data-name": "Group 25499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25498",
    "data-name": "Group 25498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25497",
    "data-name": "Group 25497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25496",
    "data-name": "Group 25496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25495",
    "data-name": "Group 25495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25494",
    "data-name": "Group 25494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34419",
    "data-name": "Path 34419",
    d: "M279.965,136.727c-.044.07-1.281,1.991-2.668,2.386l-.006-.008.158-1.436A4.959,4.959,0,0,0,279.965,136.727Z",
    transform: "translate(-277.291 -136.727)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25509",
    "data-name": "Group 25509",
    transform: "translate(0 16.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25508",
    "data-name": "Group 25508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25507",
    "data-name": "Group 25507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25506",
    "data-name": "Group 25506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25505",
    "data-name": "Group 25505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25504",
    "data-name": "Group 25504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25503",
    "data-name": "Group 25503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25502",
    "data-name": "Group 25502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34420",
    "data-name": "Path 34420",
    d: "M277.079,126.261s-2.118-4.085-4.582-1.553c-2.03,2.087.06,8.738,3.656,7.166Z",
    transform: "translate(-271.701 -123.88)",
    fill: "#ebb088"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25517",
    "data-name": "Group 25517",
    transform: "translate(1.79 17.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25516",
    "data-name": "Group 25516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25515",
    "data-name": "Group 25515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25514",
    "data-name": "Group 25514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25513",
    "data-name": "Group 25513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25512",
    "data-name": "Group 25512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25511",
    "data-name": "Group 25511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25510",
    "data-name": "Group 25510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34421",
    "data-name": "Path 34421",
    d: "M277.325,132.1l.031,0a.283.283,0,0,0,.3-.267,5.284,5.284,0,0,0-2.369-4.714.283.283,0,1,0-.293.484h0a4.716,4.716,0,0,1,2.1,4.2A.283.283,0,0,0,277.325,132.1Z",
    transform: "translate(-274.855 -127.087)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25525",
    "data-name": "Group 25525",
    transform: "translate(1.69 19.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25524",
    "data-name": "Group 25524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25523",
    "data-name": "Group 25523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25522",
    "data-name": "Group 25522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25521",
    "data-name": "Group 25521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25520",
    "data-name": "Group 25520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25519",
    "data-name": "Group 25519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25518",
    "data-name": "Group 25518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34422",
    "data-name": "Path 34422",
    d: "M274.917,131.454a.285.285,0,0,0,.186-.033h0a2.229,2.229,0,0,1,1.555-.317.282.282,0,1,0,.228-.517,2.736,2.736,0,0,0-2.064.343.282.282,0,0,0,.1.524Z",
    transform: "translate(-274.679 -130.48)",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25533",
    "data-name": "Group 25533",
    transform: "translate(16.897 14.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25532",
    "data-name": "Group 25532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25531",
    "data-name": "Group 25531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25530",
    "data-name": "Group 25530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25529",
    "data-name": "Group 25529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25528",
    "data-name": "Group 25528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25527",
    "data-name": "Group 25527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25526",
    "data-name": "Group 25526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34423",
    "data-name": "Path 34423",
    d: "M301.715,128.31a2.426,2.426,0,0,0,2.439-.835.281.281,0,0,0,.037-.24c-.751-2.52-1.507-5.108-1.515-5.134a.284.284,0,0,0-.545.158c.007.026.735,2.517,1.473,4.993a1.949,1.949,0,0,1-1.8.5.283.283,0,1,0-.092.558Z",
    transform: "translate(-301.476 -121.897)",
    fill: "#341a1b"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25651",
    "data-name": "Group 25651",
    transform: "translate(0 78.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25650",
    "data-name": "Group 25650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25593",
    "data-name": "Group 25593",
    transform: "translate(3.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25567",
    "data-name": "Group 25567",
    transform: "translate(0 52.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25543",
    "data-name": "Group 25543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25542",
    "data-name": "Group 25542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25541",
    "data-name": "Group 25541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25540",
    "data-name": "Group 25540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25539",
    "data-name": "Group 25539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25538",
    "data-name": "Group 25538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34424",
    "data-name": "Path 34424",
    d: "M229.521,335.243s-.952.4-2.492,1.074c-.439.192-.925.406-1.45.64-.7.31-1.462.654-2.276,1.027q-.7.318-1.44.663c-6.142,2.854-14.214,6.923-17.189,9.848-.209.205-.41.408-.6.608-4.491,4.651-4.912,7.927-6.018,7.518-1.154-.426-1.946-3.02-.662-5.111.89-1.449,1.318-3.376,2.452-5.6a17.765,17.765,0,0,1,1.1-1.87c1.912-2.839,5.255-6.064,7.014-8.37.113-.149.22-.294.32-.435,1.422-2.015,1.394-5.528,4.409-7.243a10.045,10.045,0,0,1,5.341-.958c.343.016.687.042,1.026.075.508.051,1.009.117,1.495.195.671.11,1.313.239,1.9.375.565.129,1.083.263,1.531.388,1.081.3,1.763.55,1.763.55Z",
    transform: "translate(-196.732 -327.011)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25548",
    "data-name": "Group 25548",
    transform: "translate(11.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25547",
    "data-name": "Group 25547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25546",
    "data-name": "Group 25546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25545",
    "data-name": "Group 25545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25544",
    "data-name": "Group 25544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34425",
    "data-name": "Path 34425",
    d: "M226.579,327.03c-1.376,2.912-4.755,8.638-10.07,8.636.113-.149.22-.294.32-.435,1.422-2.015,1.394-5.528,4.409-7.243A10.045,10.045,0,0,1,226.579,327.03Z",
    transform: "translate(-216.509 -327.011)",
    fill: "#6e3e45"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25553",
    "data-name": "Group 25553",
    transform: "translate(0 18.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25552",
    "data-name": "Group 25552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25551",
    "data-name": "Group 25551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25550",
    "data-name": "Group 25550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25549",
    "data-name": "Group 25549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34426",
    "data-name": "Path 34426",
    d: "M204.071,363.5c-4.491,4.651-4.912,7.927-6.018,7.518-1.154-.426-1.946-3.02-.662-5.111.89-1.449,1.318-3.376,2.452-5.6A9.793,9.793,0,0,1,204.071,363.5Z",
    transform: "translate(-196.732 -360.308)",
    fill: "#6e3e45"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25559",
    "data-name": "Group 25559",
    transform: "translate(25.716 0.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25558",
    "data-name": "Group 25558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25557",
    "data-name": "Group 25557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25556",
    "data-name": "Group 25556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25555",
    "data-name": "Group 25555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25554",
    "data-name": "Group 25554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34427",
    "data-name": "Path 34427",
    d: "M246.628,336.823c-.439.192-.925.406-1.45.64a12.974,12.974,0,0,1-2.755-6,20.268,20.268,0,0,1-.377-3.283c.565.129,1.083.263,1.531.388a18.627,18.627,0,0,0,.332,2.608A11.316,11.316,0,0,0,246.628,336.823Z",
    transform: "translate(-242.047 -328.181)",
    fill: "#6e3e45"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25566",
    "data-name": "Group 25566",
    transform: "translate(22.171 0.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25565",
    "data-name": "Group 25565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25564",
    "data-name": "Group 25564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25563",
    "data-name": "Group 25563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25562",
    "data-name": "Group 25562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25561",
    "data-name": "Group 25561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25560",
    "data-name": "Group 25560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34428",
    "data-name": "Path 34428",
    d: "M237.444,327.373c-.486-.077-.986-.144-1.495-.195a20.42,20.42,0,0,0-.055,4.384,12.327,12.327,0,0,0,2.867,7.157q.741-.344,1.44-.663C236.941,334.822,237.2,329.439,237.444,327.373Z",
    transform: "translate(-235.802 -327.178)",
    fill: "#6e3e45"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25572",
    "data-name": "Group 25572",
    transform: "translate(28.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25571",
    "data-name": "Group 25571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25570",
    "data-name": "Group 25570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25569",
    "data-name": "Group 25569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25568",
    "data-name": "Group 25568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34429",
    "data-name": "Path 34429",
    d: "M247.678,285.734c-.477,10.115,5.821,10.748,5.821,10.748a21.341,21.341,0,0,0,4.288-.825q.421-.112.885-.243c1.94-.553,4.477-1.391,7.689-2.663q.569-.226,1.171-.473c2.105-.859,4.479-1.895,7.14-3.143,4.022-1.886,8.7-4.252,14.1-7.229,15.556-8.575,29.252-20.542,34.358-30.467,3.45-6.7,2.982-12.464-3.472-15.629a10.9,10.9,0,0,0-3.551-1.023c-8.175-.948-16.426,6.841-16.426,6.841-16.58,11.118-21.744,20.6-28.527,28.212q-.42.473-.85.936c-.185.2-.374.395-.57.593a40.147,40.147,0,0,1-3.692,3.273,96.179,96.179,0,0,1-13.686,8.719q-.4.215-.777.413C249.228,285.011,247.678,285.734,247.678,285.734Z",
    transform: "translate(-247.653 -234.706)",
    fill: "#341a1b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25577",
    "data-name": "Group 25577",
    transform: "translate(32.82 48.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25576",
    "data-name": "Group 25576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25575",
    "data-name": "Group 25575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25574",
    "data-name": "Group 25574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25573",
    "data-name": "Group 25573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34430",
    "data-name": "Path 34430",
    d: "M254.566,320.857a17.864,17.864,0,0,0,.615,2.177q.145.408.3.81a38.032,38.032,0,0,0,5.294,8.9q.421-.112.885-.243a38.256,38.256,0,0,1-5.431-9.072q-.159-.4-.3-.812a16.086,16.086,0,0,1-.588-2.168Q254.942,320.659,254.566,320.857Z",
    transform: "translate(-254.566 -320.444)",
    fill: "#6e3e45"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25581",
    "data-name": "Group 25581",
    transform: "translate(97.155 0.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25580",
    "data-name": "Group 25580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25579",
    "data-name": "Group 25579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25578",
    "data-name": "Group 25578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34431",
    "data-name": "Path 34431",
    d: "M375.151,251.5c-7.349-6.448-7.591-13.114-7.024-16.652a10.855,10.855,0,0,1,3.551,1.023C378.132,239.035,378.6,244.8,375.151,251.5Z",
    transform: "translate(-367.934 -234.849)",
    fill: "#6e3e45"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25587",
    "data-name": "Group 25587",
    transform: "translate(33.435 9.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25586",
    "data-name": "Group 25586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25585",
    "data-name": "Group 25585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25584",
    "data-name": "Group 25584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25583",
    "data-name": "Group 25583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25582",
    "data-name": "Group 25582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34432",
    "data-name": "Path 34432",
    d: "M255.65,293.272q.145.408.3.81c.244-.136.493-.275.747-.421,6.052-3.454,15.049-9.817,25.188-17.861,9.5-7.54,20.344-16.955,21.684-19.807.724-1.541.773-2.71.148-3.473-.936-1.142-3.036-.919-3.981-.749a.427.427,0,1,0,.148.842c.929-.165,2.576-.282,3.173.448.5.607.132,1.732-.261,2.568-1.081,2.3-10.1,10.5-21.441,19.5-8.017,6.359-18.039,13.741-24.959,17.718C256.146,293,255.9,293.137,255.65,293.272Z",
    transform: "translate(-255.65 -251.632)",
    fill: "#6e3e45"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25592",
    "data-name": "Group 25592",
    transform: "translate(27.272 49.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25591",
    "data-name": "Group 25591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25590",
    "data-name": "Group 25590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25589",
    "data-name": "Group 25589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25588",
    "data-name": "Group 25588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34433",
    "data-name": "Path 34433",
    d: "M248.391,321.626c1.525,5.016,3.647,9.448,7.15,12.529,0,0-2.175,2.207-4.658,1.311-1.9-.684-6.593-8.123-6.049-12.613C246.146,321.817,247.348,321.329,248.391,321.626Z",
    transform: "translate(-244.79 -321.54)",
    fill: "#6e3e45"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25649",
    "data-name": "Group 25649",
    transform: "translate(0 2.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25623",
    "data-name": "Group 25623",
    transform: "translate(76.742 48.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25599",
    "data-name": "Group 25599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25598",
    "data-name": "Group 25598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25597",
    "data-name": "Group 25597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25596",
    "data-name": "Group 25596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25595",
    "data-name": "Group 25595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25594",
    "data-name": "Group 25594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34434",
    "data-name": "Path 34434",
    d: "M325.595,333.559s.97.35,2.543.948c.448.17.944.359,1.479.566.711.276,1.492.581,2.324.913q.713.283,1.471.591c6.278,2.545,14.541,6.206,17.658,8.979.219.195.43.387.633.578,4.717,4.422,5.3,7.672,6.384,7.209,1.132-.483,1.794-3.113.406-5.137-.961-1.4-1.484-3.306-2.727-5.474a17.859,17.859,0,0,0-1.189-1.813c-2.051-2.74-5.551-5.795-7.423-8.011-.12-.142-.234-.283-.341-.418-1.521-1.941-1.667-5.451-4.765-7.014a10.046,10.046,0,0,0-5.382-.691c-.342.033-.684.076-1.021.126-.505.075-1,.168-1.483.269-.665.143-1.3.3-1.881.469-.558.157-1.068.317-1.509.464-1.065.355-1.734.638-1.734.638Z",
    transform: "translate(-325.595 -324.706)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25604",
    "data-name": "Group 25604",
    transform: "translate(11.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25603",
    "data-name": "Group 25603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25602",
    "data-name": "Group 25602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25601",
    "data-name": "Group 25601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25600",
    "data-name": "Group 25600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34435",
    "data-name": "Path 34435",
    d: "M345.106,324.784c1.519,2.84,5.179,8.39,10.488,8.123-.12-.142-.234-.283-.341-.418-1.521-1.941-1.667-5.451-4.765-7.014A10.046,10.046,0,0,0,345.106,324.784Z",
    transform: "translate(-345.106 -324.706)",
    fill: "#6e3e45"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25609",
    "data-name": "Group 25609",
    transform: "translate(26.109 18.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25608",
    "data-name": "Group 25608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25607",
    "data-name": "Group 25607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25606",
    "data-name": "Group 25606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25605",
    "data-name": "Group 25605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34436",
    "data-name": "Path 34436",
    d: "M371.6,359.872c4.717,4.422,5.3,7.672,6.384,7.209,1.132-.483,1.794-3.113.406-5.137-.961-1.4-1.484-3.306-2.727-5.475A9.8,9.8,0,0,0,371.6,359.872Z",
    transform: "translate(-371.603 -356.469)",
    fill: "#6e3e45"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25615",
    "data-name": "Group 25615",
    transform: "translate(2.543 0.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25614",
    "data-name": "Group 25614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25613",
    "data-name": "Group 25613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25612",
    "data-name": "Group 25612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25611",
    "data-name": "Group 25611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25610",
    "data-name": "Group 25610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34437",
    "data-name": "Path 34437",
    d: "M330.076,335.226c.448.17.944.359,1.479.566a12.978,12.978,0,0,0,2.453-6.128,20.283,20.283,0,0,0,.212-3.3c-.558.157-1.068.317-1.509.464a18.657,18.657,0,0,1-.2,2.621A11.325,11.325,0,0,1,330.076,335.226Z",
    transform: "translate(-330.076 -326.366)",
    fill: "#6e3e45"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25622",
    "data-name": "Group 25622",
    transform: "translate(6.347 0.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25621",
    "data-name": "Group 25621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25620",
    "data-name": "Group 25620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25619",
    "data-name": "Group 25619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25618",
    "data-name": "Group 25618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25617",
    "data-name": "Group 25617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25616",
    "data-name": "Group 25616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34438",
    "data-name": "Path 34438",
    d: "M336.779,336.143q.712.283,1.471.591a12.33,12.33,0,0,0,2.507-7.291,20.438,20.438,0,0,0-.274-4.376c-.505.075-1,.168-1.483.269C339.347,327.386,339.873,332.75,336.779,336.143Z",
    transform: "translate(-336.779 -325.066)",
    fill: "#6e3e45"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25628",
    "data-name": "Group 25628",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25627",
    "data-name": "Group 25627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25626",
    "data-name": "Group 25626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25625",
    "data-name": "Group 25625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25624",
    "data-name": "Group 25624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34439",
    "data-name": "Path 34439",
    d: "M193.473,257.432c5.968,9.428,20.389,19.4,35.805,26.919,14.7,7.172,23.926,10.57,29.257,12.175.178.054.351.106.519.154a30.421,30.421,0,0,0,5.6,1.275s6.259-.945,5.279-11.025l-4.608-3.6q-.359-.279-.735-.575c-5.253-4.108-13.218-10.337-18.437-14.411-14.621-11.415-15.975-10.756-29.452-21.96,0,0-8.483-7.543-16.273-7.076a11.35,11.35,0,0,0-4.868,1.352C188.954,244.31,189.09,250.51,193.473,257.432Z",
    transform: "translate(-190.363 -239.281)",
    fill: "#341a1b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25633",
    "data-name": "Group 25633",
    transform: "translate(68.104 43.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25632",
    "data-name": "Group 25632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25631",
    "data-name": "Group 25631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25630",
    "data-name": "Group 25630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25629",
    "data-name": "Group 25629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34440",
    "data-name": "Path 34440",
    d: "M310.442,329.655a.39.39,0,0,0,.061.073.428.428,0,0,0,.21.108.408.408,0,0,0,.249-.028.389.389,0,0,0,.138-.1c2.95-3.1,4.718-8.071,5.574-11.077.086-.3.164-.585.232-.843.153-.581.26-1.042.327-1.338q-.359-.279-.735-.575a.238.238,0,0,0-.013.046c0,.02-.118.574-.35,1.46-.066.256-.143.541-.23.848-.826,2.915-2.564,7.906-5.414,10.9A.42.42,0,0,0,310.442,329.655Z",
    transform: "translate(-310.372 -315.879)",
    fill: "#6e3e45"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25637",
    "data-name": "Group 25637",
    transform: "translate(0 0.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25636",
    "data-name": "Group 25636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25635",
    "data-name": "Group 25635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25634",
    "data-name": "Group 25634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34441",
    "data-name": "Path 34441",
    d: "M200.429,239.318c-.024,3.374-.589,14.608-6.956,18.129-4.383-6.922-4.519-13.121,2.088-16.778A11.359,11.359,0,0,1,200.429,239.318Z",
    transform: "translate(-190.363 -239.318)",
    fill: "#6e3e45"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25643",
    "data-name": "Group 25643",
    transform: "translate(25.557 6.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25642",
    "data-name": "Group 25642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25641",
    "data-name": "Group 25641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25640",
    "data-name": "Group 25640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25639",
    "data-name": "Group 25639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25638",
    "data-name": "Group 25638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34442",
    "data-name": "Path 34442",
    d: "M236.091,255.624c1.48,2.782,12.775,11.645,22.643,18.7a240.884,240.884,0,0,0,24.741,15.907c.261.139.518.274.77.4.086-.3.164-.585.232-.843q-.38-.2-.771-.407a254.063,254.063,0,0,1-24.475-15.753c-11.778-8.423-21.192-16.165-22.387-18.409-.434-.815-.854-1.922-.389-2.551.562-.759,2.213-.725,3.149-.607a.341.341,0,0,0,.053,0,.427.427,0,0,0,.052-.851c-.952-.124-3.06-.242-3.938.947C235.182,252.956,235.29,254.12,236.091,255.624Z",
    transform: "translate(-235.397 -251.141)",
    fill: "#6e3e45"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25648",
    "data-name": "Group 25648",
    transform: "translate(71.024 45.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25647",
    "data-name": "Group 25647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25646",
    "data-name": "Group 25646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25645",
    "data-name": "Group 25645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25644",
    "data-name": "Group 25644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34443",
    "data-name": "Path 34443",
    d: "M322.035,320.4c-1.274,5.085-3.172,9.618-6.517,12.869,0,0,2.282,2.1,4.717,1.078,1.86-.777,6.18-8.441,5.413-12.9C324.286,320.474,323.062,320.047,322.035,320.4Z",
    transform: "translate(-315.518 -320.275)",
    fill: "#6e3e45"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25673",
    "data-name": "Group 25673",
    transform: "translate(63.144 40.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25655",
    "data-name": "Group 25655",
    transform: "translate(9.489 10.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25654",
    "data-name": "Group 25654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25653",
    "data-name": "Group 25653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25652",
    "data-name": "Group 25652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34444",
    "data-name": "Path 34444",
    d: "M342.307,218.921c-2.178,5.117-7.208,4.909-12.579-2.922a141.763,141.763,0,0,1-7.959-13.243c-1.428-2.676-2.587-5.022-3.415-6.756q.125-2.088.2-4.178l10.411-6.589s3.311,5.23,6.682,11.687C339.818,204.9,344.08,214.754,342.307,218.921Z",
    transform: "translate(-318.354 -185.233)",
    fill: "#ebb088"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25659",
    "data-name": "Group 25659",
    transform: "translate(0 36.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25658",
    "data-name": "Group 25658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25657",
    "data-name": "Group 25657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25656",
    "data-name": "Group 25656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34445",
    "data-name": "Path 34445",
    d: "M301.633,249.244c4.661-3.137,10.392-6.826,12.659-8.828,5.595-4.938,15.411-12.847,20.486-8.882,0,0,4.168,8.242-2.78,13.626-6.62,5.13-21.42,10.779-28.319,12.923A68.779,68.779,0,0,1,301.633,249.244Z",
    transform: "translate(-301.633 -230.458)",
    fill: "#ebb088"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25668",
    "data-name": "Group 25668",
    transform: "translate(19.787 36.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25663",
    "data-name": "Group 25663",
    transform: "translate(0 0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25662",
    "data-name": "Group 25662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25661",
    "data-name": "Group 25661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25660",
    "data-name": "Group 25660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34446",
    "data-name": "Path 34446",
    d: "M336.861,234.834a.342.342,0,0,0,.208-.082,24.15,24.15,0,0,1,6.314-3.6.345.345,0,1,0-.238-.648,24.436,24.436,0,0,0-6.524,3.725.345.345,0,0,0,.24.607Z",
    transform: "translate(-336.5 -230.48)",
    fill: "#ff7d5b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25667",
    "data-name": "Group 25667",
    transform: "translate(0.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25666",
    "data-name": "Group 25666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25665",
    "data-name": "Group 25665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25664",
    "data-name": "Group 25664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34447",
    "data-name": "Path 34447",
    d: "M337.86,234.326a.345.345,0,0,0,.326-.294c.231-1.54,2.172-3.029,2.192-3.044a.345.345,0,0,0-.418-.55c-.089.068-2.184,1.676-2.457,3.492a.345.345,0,0,0,.29.393A.334.334,0,0,0,337.86,234.326Z",
    transform: "translate(-337.499 -230.368)",
    fill: "#ff7d5b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25672",
    "data-name": "Group 25672",
    transform: "translate(9.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25671",
    "data-name": "Group 25671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25670",
    "data-name": "Group 25670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25669",
    "data-name": "Group 25669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34448",
    "data-name": "Path 34448",
    d: "M336.273,188.375s-.316.232-.9.612a42.068,42.068,0,0,1-13.88,5.836c-.523.107-1.054.2-1.591.28,0,0-.9-.882-2.184-2.32q.219-2.355.359-4.717.125-2.088.2-4.178c.212-5.66.186-11.332.167-17C322.8,169.515,329.618,175.4,336.273,188.375Z",
    transform: "translate(-317.721 -166.892)",
    fill: "#7c7a48"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25699",
    "data-name": "Group 25699",
    transform: "translate(5.988 38.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25677",
    "data-name": "Group 25677",
    transform: "translate(0.532 12.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25676",
    "data-name": "Group 25676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25675",
    "data-name": "Group 25675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25674",
    "data-name": "Group 25674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34449",
    "data-name": "Path 34449",
    d: "M215.6,185.234s-16.548,26.147-13.339,33.688c2.177,5.116,7.208,4.91,12.578-2.921a157.927,157.927,0,0,0,12.821-23.136Z",
    transform: "translate(-201.851 -185.234)",
    fill: "#ebb088"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25681",
    "data-name": "Group 25681",
    transform: "translate(0 38.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25680",
    "data-name": "Group 25680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25679",
    "data-name": "Group 25679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25678",
    "data-name": "Group 25678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34450",
    "data-name": "Path 34450",
    d: "M235.3,249.244c-4.661-3.137-10.392-6.826-12.659-8.828-5.595-4.938-15.411-12.847-20.486-8.882,0,0-4.169,8.242,2.78,13.626,6.62,5.13,21.42,10.779,28.319,12.923A68.874,68.874,0,0,0,235.3,249.244Z",
    transform: "translate(-200.915 -230.458)",
    fill: "#ebb088"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25690",
    "data-name": "Group 25690",
    transform: "translate(7.49 38.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25685",
    "data-name": "Group 25685",
    transform: "translate(0 0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25684",
    "data-name": "Group 25684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25683",
    "data-name": "Group 25683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25682",
    "data-name": "Group 25682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34451",
    "data-name": "Path 34451",
    d: "M220.862,234.834a.344.344,0,0,1-.209-.082,24.151,24.151,0,0,0-6.313-3.6.345.345,0,1,1,.238-.648,24.437,24.437,0,0,1,6.524,3.725.345.345,0,0,1-.24.607Z",
    transform: "translate(-214.113 -230.48)",
    fill: "#ff7d5b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25689",
    "data-name": "Group 25689",
    transform: "translate(3.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25688",
    "data-name": "Group 25688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25687",
    "data-name": "Group 25687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25686",
    "data-name": "Group 25686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34452",
    "data-name": "Path 34452",
    d: "M222.983,234.326a.345.345,0,0,1-.326-.294c-.231-1.54-2.172-3.029-2.192-3.044a.345.345,0,1,1,.418-.55c.089.068,2.184,1.676,2.457,3.492a.345.345,0,0,1-.29.393A.336.336,0,0,1,222.983,234.326Z",
    transform: "translate(-220.329 -230.368)",
    fill: "#ff7d5b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25694",
    "data-name": "Group 25694",
    transform: "translate(6.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25693",
    "data-name": "Group 25693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25692",
    "data-name": "Group 25692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25691",
    "data-name": "Group 25691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34453",
    "data-name": "Path 34453",
    d: "M235.17,163.3s-11.449,2.088-22.441,23.518a41.354,41.354,0,0,0,16.369,6.729s8.285-8.133,10.482-15.248S239.381,165.96,235.17,163.3Z",
    transform: "translate(-212.729 -163.305)",
    fill: "#7c7a48"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25696",
    "data-name": "Group 25696",
    transform: "translate(23.167 17.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25695",
    "data-name": "Group 25695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34454",
    "data-name": "Path 34454",
    d: "M242.017,206.822a.277.277,0,0,0,.179-.065A38.919,38.919,0,0,0,251.24,194.6a.278.278,0,1,0-.507-.227,38.317,38.317,0,0,1-8.894,11.954.278.278,0,0,0,.179.491Z",
    transform: "translate(-241.739 -194.213)",
    fill: "#504f2c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25698",
    "data-name": "Group 25698",
    transform: "translate(29.718 20.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25697",
    "data-name": "Group 25697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34455",
    "data-name": "Path 34455",
    d: "M253.56,201.109a.262.262,0,0,0,.047,0,10.468,10.468,0,0,0,3.976-1.8.278.278,0,0,0-.336-.443,10.066,10.066,0,0,1-3.733,1.692.278.278,0,0,0,.047.552Z",
    transform: "translate(-253.282 -198.809)",
    fill: "#504f2c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25701",
    "data-name": "Group 25701",
    transform: "translate(73.448 42.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25700",
    "data-name": "Group 25700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34456",
    "data-name": "Path 34456",
    d: "M320.778,185.769a.277.277,0,0,0,.277-.257c.032-.426.772-10.464-.725-14.759a.278.278,0,0,0-.525.183c1.459,4.187.7,14.431.7,14.534a.277.277,0,0,0,.256.3Z",
    transform: "translate(-319.79 -170.567)",
    fill: "#504f2c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25718",
    "data-name": "Group 25718",
    transform: "translate(33.329 79.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25704",
    "data-name": "Group 25704",
    transform: "translate(0 23.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25703",
    "data-name": "Group 25703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25702",
    "data-name": "Group 25702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34457",
    "data-name": "Path 34457",
    d: "M252.569,285.624l-3.211-6.107a2.272,2.272,0,0,1,2.036-3.33l50.476.544-1.489,7.819Z",
    transform: "translate(-249.094 -276.187)",
    fill: "#ddd8ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25707",
    "data-name": "Group 25707",
    transform: "translate(3.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25706",
    "data-name": "Group 25706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25705",
    "data-name": "Group 25705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34458",
    "data-name": "Path 34458",
    d: "M301.9,267.088H256.73a1.733,1.733,0,0,1-1.756-1.974l3.08-27.909a2.261,2.261,0,0,1,2.192-1.974h45.172a1.734,1.734,0,0,1,1.756,1.974l-3.08,27.909A2.261,2.261,0,0,1,301.9,267.088Z",
    transform: "translate(-254.962 -235.232)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25710",
    "data-name": "Group 25710",
    transform: "translate(4.189 1.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25709",
    "data-name": "Group 25709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25708",
    "data-name": "Group 25708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34459",
    "data-name": "Path 34459",
    d: "M256.857,268.543a.342.342,0,0,1-.048,0,.38.38,0,0,1-.33-.426l3.749-29.893a.381.381,0,0,1,.756.1l-3.749,29.893A.381.381,0,0,1,256.857,268.543Z",
    transform: "translate(-256.475 -237.888)",
    fill: "#ddd8ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25714",
    "data-name": "Group 25714",
    transform: "translate(26.534 11.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25713",
    "data-name": "Group 25713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25712",
    "data-name": "Group 25712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25711",
    "data-name": "Group 25711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34460",
    "data-name": "Path 34460",
    d: "M295.864,259.689A3.977,3.977,0,0,0,299.552,264a4.105,4.105,0,0,0,4.313-3.8,3.976,3.976,0,0,0-3.688-4.314A4.105,4.105,0,0,0,295.864,259.689Z",
    transform: "translate(-295.851 -255.877)",
    fill: "#ddd8ce"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25717",
    "data-name": "Group 25717",
    transform: "translate(3.176 28.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25716",
    "data-name": "Group 25716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25715",
    "data-name": "Group 25715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34461",
    "data-name": "Path 34461",
    d: "M302.148,290.2H256.353a1.661,1.661,0,0,1-1.646-1.886l.436-3.192h49.148l-.5,3.641A1.661,1.661,0,0,1,302.148,290.2Z",
    transform: "translate(-254.692 -285.123)",
    fill: "#ddd8ce"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25742",
    "data-name": "Group 25742",
    transform: "translate(0 89.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25723",
    "data-name": "Group 25723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25722",
    "data-name": "Group 25722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25721",
    "data-name": "Group 25721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25720",
    "data-name": "Group 25720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34462",
    "data-name": "Path 34462",
    d: "M129.253,277.066a33.416,33.416,0,0,1-.14-7.433,17.448,17.448,0,0,1,12.421-15.355c5.713-1.688,13.254-2.731,20.971-.4.565.171,1.134.36,1.7.569,16.474,6.057,14.051,37.552,11.385,55.237s-2.907,28.345-10.418,30.042c-3.449.779-8.48.842-12.915.683-.923-.033-1.821-.076-2.673-.124,0,0-9.337.813-14.126-3.293S129.253,277.066,129.253,277.066Z",
    transform: "translate(-128.985 -252.524)",
    fill: "#bf632d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25728",
    "data-name": "Group 25728",
    transform: "translate(23.273 1.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25727",
    "data-name": "Group 25727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25726",
    "data-name": "Group 25726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25725",
    "data-name": "Group 25725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25724",
    "data-name": "Group 25724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34463",
    "data-name": "Path 34463",
    d: "M169.995,341.444c4.435.158,9.467.1,12.915-.683,7.511-1.7,7.753-12.355,10.418-30.042s5.088-49.181-11.385-55.237c-.567-.208-1.136-.4-1.7-.569-2.807.67-5.387,2.533-6.779,6.625C169.688,272.638,175.681,311.208,169.995,341.444Z",
    transform: "translate(-169.995 -254.913)",
    fill: "#fe812d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25732",
    "data-name": "Group 25732",
    transform: "translate(27.153 38.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25731",
    "data-name": "Group 25731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25730",
    "data-name": "Group 25730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25729",
    "data-name": "Group 25729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34464",
    "data-name": "Path 34464",
    d: "M182.252,366.953a8.5,8.5,0,0,0,7.709-4.1c2.544-4.2,6.215-40.266,6.37-41.8a.342.342,0,1,0-.681-.069c-.037.374-3.81,37.441-6.275,41.513-1.559,2.577-4.054,3.843-7.4,3.766a14.756,14.756,0,0,1-4.669-.918.342.342,0,1,0-.259.633,15.2,15.2,0,0,0,4.893.968C182.043,366.951,182.148,366.953,182.252,366.953Z",
    transform: "translate(-176.832 -320.678)",
    fill: "#bf632d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25736",
    "data-name": "Group 25736",
    transform: "translate(28.92 4.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25735",
    "data-name": "Group 25735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25734",
    "data-name": "Group 25734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25733",
    "data-name": "Group 25733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34465",
    "data-name": "Path 34465",
    d: "M180.289,267.985a.342.342,0,0,0,.342-.342,7.667,7.667,0,0,1,2.593-5.169,4.642,4.642,0,0,1,4.145-.827c4,.956,5.174,6.019,5.186,6.07a.342.342,0,0,0,.668-.148c-.05-.225-1.274-5.531-5.695-6.588a5.3,5.3,0,0,0-4.728.956,8.3,8.3,0,0,0-2.854,5.705A.342.342,0,0,0,180.289,267.985Z",
    transform: "translate(-179.947 -260.798)",
    fill: "#bf632d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25741",
    "data-name": "Group 25741",
    transform: "translate(31.048 8.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25740",
    "data-name": "Group 25740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25739",
    "data-name": "Group 25739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25738",
    "data-name": "Group 25738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25737",
    "data-name": "Group 25737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34466",
    "data-name": "Path 34466",
    d: "M183.7,272.923s.269-6.052,4.837-5.573,4.787,10.465.7,11.755C183.27,281,183.7,272.923,183.7,272.923Z",
    transform: "translate(-183.697 -267.323)",
    fill: "#bf632d"
  })))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25782",
    "data-name": "Group 25782",
    transform: "translate(42.307 9.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25743",
    "data-name": "Group 25743",
    transform: "translate(9.21 15.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34467",
    "data-name": "Path 34467",
    d: "M256.132,154.832c-.1,5.227-2.012,10.495-16.639,6.416-.918-.256-8.41-4.129-11.378-1.024-3.154,3.3-3.11,5.391-6.335,1.565,0,0-7.523-14.441,6.521-20.385a15.152,15.152,0,0,1,2.333-.682q.671-.162,1.321-.3,1.661-.349,3.186-.535c1.085-.136,2.12-.213,3.107-.238h0a25.893,25.893,0,0,1,2.892.082,21.223,21.223,0,0,1,2.48.354C252.915,141.981,256.234,149.515,256.132,154.832Z",
    transform: "translate(-219.766 -139.644)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25746",
    "data-name": "Group 25746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25744",
    "data-name": "Group 25744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34468",
    "data-name": "Path 34468",
    d: "M212.707,117.9a22.369,22.369,0,0,0,4.275-3.19c4.947-4.821,9.047,1.531,6.137,5-1.793,2.137-4.661,3.176-7.474,3.953-4.608,1.276-9.065,1.851-8.388,5.417,1.088,5.742,15.336.356,15.336.356.211,4.659-1.411,9-9.892,12.155,0,0-11.5-8.583-8.733-15.4C205.939,121.353,209.223,119.989,212.707,117.9Z",
    transform: "translate(-203.537 -112.967)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25745",
    "data-name": "Group 25745",
    transform: "translate(9.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34469",
    "data-name": "Path 34469",
    d: "M219.691,117.9a22.369,22.369,0,0,0,4.275-3.19c4.947-4.821,9.047,1.531,6.137,5-1.793,2.137-4.661,3.176-7.474,3.953a4.052,4.052,0,0,1-2.031-1.629A6.8,6.8,0,0,1,219.691,117.9Z",
    transform: "translate(-219.685 -112.967)",
    fill: "#6e3e45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25747",
    "data-name": "Group 25747",
    transform: "translate(14.665 15.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34470",
    "data-name": "Path 34470",
    d: "M236.112,141.022c-5.867,4.233-6.54,13.844-6.54,13.844A18.129,18.129,0,0,1,232.458,142q1.1-.383,2.333-.682Q235.461,141.156,236.112,141.022Z",
    transform: "translate(-229.379 -141.022)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25748",
    "data-name": "Group 25748",
    transform: "translate(25.469 15.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34471",
    "data-name": "Path 34471",
    d: "M256.013,140.158c-5.414,3.588-7.6,11.327-7.6,11.327a18.144,18.144,0,0,1,5.116-11.681A21.229,21.229,0,0,1,256.013,140.158Z",
    transform: "translate(-248.417 -139.804)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25749",
    "data-name": "Group 25749",
    transform: "translate(20.264 15.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34472",
    "data-name": "Path 34472",
    d: "M246.672,139.66c-5.6,3.3-7.427,11.591-7.427,11.591a16.869,16.869,0,0,1,4.32-11.354C244.65,139.762,245.684,139.685,246.672,139.66Z",
    transform: "translate(-239.245 -139.66)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25751",
    "data-name": "Group 25751",
    transform: "translate(27.75 32.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25750",
    "data-name": "Group 25750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34473",
    "data-name": "Path 34473",
    d: "M259.867,190.212c-.961-.216-1.693-1.389-2.346-3.033-.221-.555-.432-1.163-.64-1.806-.222-.684-.439-1.407-.662-2.146a34.731,34.731,0,0,0-3-7.861c-2.921-4.694,3.27-5.227,3.27-5.227s4.327-2.059,3.45.643c-.713,2.2.169,7.539,1.191,10.857a14.722,14.722,0,0,0,.708,1.9c.016.034.032.068.047.1a6.935,6.935,0,0,1,.42,1.256C262.925,187.5,262.329,190.765,259.867,190.212Z",
    transform: "translate(-252.437 -169.389)",
    fill: "#341a1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25752",
    "data-name": "Group 25752",
    transform: "translate(32.836 47.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34474",
    "data-name": "Path 34474",
    d: "M265.645,201.431a1.9,1.9,0,0,1-.233.244,1.564,1.564,0,0,1-.522.306,1.122,1.122,0,0,1-.278.079,1.835,1.835,0,0,1-.533.023,2.53,2.53,0,0,1-.335-.051c-.011,0-.017-.006-.028-.011-.948-.227-1.668-1.4-2.315-3.025a14.958,14.958,0,0,1,4.784-2.281C266.592,198.423,266.473,200.421,265.645,201.431Z",
    transform: "translate(-261.4 -196.715)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25753",
    "data-name": "Group 25753",
    transform: "translate(34.297 50.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34475",
    "data-name": "Path 34475",
    d: "M265.192,204.531a2.535,2.535,0,0,1-.335-.051c-.011,0-.017-.006-.028-.011a10.067,10.067,0,0,1-.846-1.912.136.136,0,0,1,.091-.176.14.14,0,0,1,.176.091A10.035,10.035,0,0,0,265.192,204.531Z",
    transform: "translate(-263.975 -202.374)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25754",
    "data-name": "Group 25754",
    transform: "translate(35.337 50.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34476",
    "data-name": "Path 34476",
    d: "M266.8,204.117a1.12,1.12,0,0,1-.278.079,9.72,9.72,0,0,1-.709-2.383.144.144,0,0,1,.119-.159.143.143,0,0,1,.165.119A9.581,9.581,0,0,0,266.8,204.117Z",
    transform: "translate(-265.807 -201.652)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25755",
    "data-name": "Group 25755",
    transform: "translate(36.565 50.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34477",
    "data-name": "Path 34477",
    d: "M268.486,203.36a1.9,1.9,0,0,1-.233.244,10.08,10.08,0,0,1-.284-2.293.141.141,0,0,1,.148-.136.136.136,0,0,1,.136.142A10.273,10.273,0,0,0,268.486,203.36Z",
    transform: "translate(-267.97 -201.174)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25756",
    "data-name": "Group 25756",
    transform: "translate(31.911 22.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34478",
    "data-name": "Path 34478",
    d: "M276.815,172.335q-.18.465-.342.868-.112.278-.219.526c-.037.085-.073.166-.109.247a4.484,4.484,0,0,1-.961,1.5,1.978,1.978,0,0,1-1.529.485,3.168,3.168,0,0,1-.662-.1,4.7,4.7,0,0,1-1.886-1.348l-.1-.092c-.061-.054-.124-.109-.19-.165a10.977,10.977,0,0,0-1.618-1.148c-.348-.2-.741-.414-1.192-.627-4.477-2.118-.755-5.088-2.312-6.969a2.968,2.968,0,0,0-1.4-.887,10.462,10.462,0,0,0-4.523-.077s6.587-16.23,11.652-11.964c4.035,3.4,5.195,8.917,6.785,15.44C278.843,170.633,277.061,171.7,276.815,172.335Z",
    transform: "translate(-259.769 -151.869)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25757",
    "data-name": "Group 25757",
    transform: "translate(43.248 42.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34479",
    "data-name": "Path 34479",
    d: "M284.786,189.216a4.485,4.485,0,0,1-.961,1.5,1.978,1.978,0,0,1-1.529.485,3.167,3.167,0,0,1-.662-.1,4.7,4.7,0,0,1-1.886-1.348,3.884,3.884,0,0,1,.88-.644c1.607-.877,1.423-2,1.423-2A5.408,5.408,0,0,0,284.786,189.216Z",
    transform: "translate(-279.747 -187.105)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25758",
    "data-name": "Group 25758",
    transform: "translate(43.022 24.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34480",
    "data-name": "Path 34480",
    d: "M290.468,176.391c-.023.329-.054.647-.095.949a5.427,5.427,0,0,1-1.147,3.1c-1.552,1.487-2.176-.776-2.509-3.235-.044-.323-.083-.65-.119-.972-.07-.64-.125-1.262-.178-1.8-.282-2.871-4.211-9.27-6.359-11.132s1.236-6.389,1.236-6.389a16.718,16.718,0,0,1,6.253,6.793C289.242,167.018,290.741,172.536,290.468,176.391Z",
    transform: "translate(-279.348 -156.915)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25759",
    "data-name": "Group 25759",
    transform: "translate(50.388 44.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34481",
    "data-name": "Path 34481",
    d: "M295.99,192.472a5.712,5.712,0,0,1-1.073,3.025,1.02,1.02,0,0,1-.074.079,2.517,2.517,0,0,1-.409.318.949.949,0,0,1-.426.153.618.618,0,0,1-.289-.034.854.854,0,0,1-.363-.255,1.632,1.632,0,0,1-.25-.363,9.83,9.83,0,0,1-.777-3.053,4.069,4.069,0,0,1,3.3-.148A2.142,2.142,0,0,1,295.99,192.472Z",
    transform: "translate(-292.33 -191.904)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25760",
    "data-name": "Group 25760",
    transform: "translate(52.494 46.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34482",
    "data-name": "Path 34482",
    d: "M296.925,195.883a10.472,10.472,0,0,1-.4,1.26,1.008,1.008,0,0,1-.074.079,2.514,2.514,0,0,1-.409.318,10.775,10.775,0,0,0,.607-1.725.143.143,0,0,1,.17-.1A.139.139,0,0,1,296.925,195.883Z",
    transform: "translate(-296.04 -195.709)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25761",
    "data-name": "Group 25761",
    transform: "translate(51.779 46.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34483",
    "data-name": "Path 34483",
    d: "M295.484,195.468a10.115,10.115,0,0,1-.414,2.054.619.619,0,0,1-.289-.034,9.995,9.995,0,0,0,.42-2.043.142.142,0,0,1,.284.023Z",
    transform: "translate(-294.78 -195.314)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25762",
    "data-name": "Group 25762",
    transform: "translate(51.166 46.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34484",
    "data-name": "Path 34484",
    d: "M293.95,197.164a1.632,1.632,0,0,1-.25-.363,10.15,10.15,0,0,0,.023-1.492.142.142,0,1,1,.284-.023A9.937,9.937,0,0,1,293.95,197.164Z",
    transform: "translate(-293.7 -195.154)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25766",
    "data-name": "Group 25766",
    transform: "translate(33.204 41.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25763",
    "data-name": "Group 25763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34485",
    "data-name": "Path 34485",
    d: "M262.19,187.887a.142.142,0,0,1-.082-.258,10.425,10.425,0,0,1,6.494-1.973.142.142,0,0,1,.126.156.144.144,0,0,1-.156.126,10.136,10.136,0,0,0-6.3,1.923A.141.141,0,0,1,262.19,187.887Z",
    transform: "translate(-262.048 -185.639)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25764",
    "data-name": "Group 25764",
    transform: "translate(1.141 0.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34486",
    "data-name": "Path 34486",
    d: "M264.2,190.45a.142.142,0,0,1-.108-.234,10.426,10.426,0,0,1,5.8-3.521.142.142,0,0,1,.04.281,10.137,10.137,0,0,0-5.627,3.425A.14.14,0,0,1,264.2,190.45Z",
    transform: "translate(-264.058 -186.693)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25765",
    "data-name": "Group 25765",
    transform: "translate(2.85 1.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34487",
    "data-name": "Path 34487",
    d: "M267.212,192.664a.145.145,0,0,1-.061-.014.142.142,0,0,1-.067-.19,10.431,10.431,0,0,1,4.685-4.91.142.142,0,0,1,.112.261,10.14,10.14,0,0,0-4.542,4.771A.142.142,0,0,1,267.212,192.664Z",
    transform: "translate(-267.07 -187.54)",
    fill: "#6e3e45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25770",
    "data-name": "Group 25770",
    transform: "translate(48.815 37.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25767",
    "data-name": "Group 25767",
    transform: "translate(0.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34488",
    "data-name": "Path 34488",
    d: "M290.2,182.828a.142.142,0,0,1-.1-.239,10.579,10.579,0,0,1,6.106-2.81.142.142,0,0,1,.037.281,10.469,10.469,0,0,0-5.935,2.722A.141.141,0,0,1,290.2,182.828Z",
    transform: "translate(-290.053 -179.778)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25768",
    "data-name": "Group 25768",
    transform: "translate(0.198 2.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34489",
    "data-name": "Path 34489",
    d: "M290.049,185.206a.142.142,0,0,1-.071-.265,11.926,11.926,0,0,1,6.783-1.135.142.142,0,1,1-.033.281,11.641,11.641,0,0,0-6.609,1.1A.138.138,0,0,1,290.049,185.206Z",
    transform: "translate(-289.906 -183.72)",
    fill: "#6e3e45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25769",
    "data-name": "Group 25769",
    transform: "translate(0 4.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34490",
    "data-name": "Path 34490",
    d: "M296.592,187.96a.142.142,0,0,1-.053-.01,11.372,11.372,0,0,0-6.8-.528.142.142,0,1,1-.081-.272,11.688,11.688,0,0,1,6.986.537.142.142,0,0,1-.053.274Z",
    transform: "translate(-289.557 -186.851)",
    fill: "#6e3e45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25771",
    "data-name": "Group 25771",
    transform: "translate(44.971 44.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34491",
    "data-name": "Path 34491",
    d: "M285.138,192.685a1.979,1.979,0,0,1-1.529.485,3.166,3.166,0,0,1-.662-.1c-.263-.6-.355-1.378.892-1.408C284.854,191.641,285.124,192.156,285.138,192.685Z",
    transform: "translate(-282.783 -191.665)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25778",
    "data-name": "Group 25778",
    transform: "translate(42.193 32.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25772",
    "data-name": "Group 25772",
    transform: "translate(2.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34492",
    "data-name": "Path 34492",
    d: "M287.784,178.289s2.1-6.674,1.733-7.66c-.176-.477-4.346,2.053-6.61,4.39C285.456,178.006,286.325,178.582,287.784,178.289Z",
    transform: "translate(-282.906 -170.57)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25774",
    "data-name": "Group 25774",
    transform: "translate(0 7.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25773",
    "data-name": "Group 25773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34493",
    "data-name": "Path 34493",
    d: "M278.836,184.833c.132.464.04.9-.2.967s-.55-.25-.683-.714-.04-.9.2-.967S278.7,184.369,278.836,184.833Z",
    transform: "translate(-277.888 -184.109)",
    fill: "#6e3e45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25776",
    "data-name": "Group 25776",
    transform: "translate(5.141 7.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25775",
    "data-name": "Group 25775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34494",
    "data-name": "Path 34494",
    d: "M287.871,184.225c.011.482-.186.878-.441.884s-.47-.38-.481-.863.186-.878.441-.884S287.859,183.742,287.871,184.225Z",
    transform: "translate(-286.948 -183.362)",
    fill: "#6e3e45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25777",
    "data-name": "Group 25777",
    transform: "translate(4.893 1.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34495",
    "data-name": "Path 34495",
    d: "M288.759,178.135s1.162-3.712,1.475-4.584-3.725,3.1-3.725,3.1A3.476,3.476,0,0,0,288.759,178.135Z",
    transform: "translate(-286.51 -173.427)",
    fill: "#6e3e45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25781",
    "data-name": "Group 25781",
    transform: "translate(36.005 33.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25779",
    "data-name": "Group 25779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34496",
    "data-name": "Path 34496",
    d: "M269.908,178.432s-3.038-4.787-2.921-5.833c.056-.505,3.791.561,6.552,2.284C272.781,177.723,271.394,178.365,269.908,178.432Z",
    transform: "translate(-266.983 -172.473)",
    fill: "#341a1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25780",
    "data-name": "Group 25780",
    transform: "translate(1.224 1.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34497",
    "data-name": "Path 34497",
    d: "M271.585,178.265s-1.921-3.158-2.41-3.89,4.146,2.01,4.146,2.01A3.3,3.3,0,0,1,271.585,178.265Z",
    transform: "translate(-269.139 -174.251)",
    fill: "#6e3e45"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManWorking);
export default __webpack_public_path__ + "static/media/man-working.11153346d037e15ffc729484824112db.svg";
export { ForwardRef as ReactComponent };